// Toggle Button Enums
export enum ToggleButtonVariant {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum ToggleButtonSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export enum ToggleButtonColorScheme {
  INFO = 'info',
  PRIMARY = 'primary',
}

export enum ToggleButtonState {
  DEFAULT = 'default',
  HOVER = 'hover',
  SELECTED = 'selected',
  DISABLED = 'disabled',
}

// Height mapping
export const TOGGLE_BUTTON_HEIGHTS = {
  [ToggleButtonSize.SM]: 32,
  [ToggleButtonSize.MD]: 36,
  [ToggleButtonSize.LG]: 42,
  [ToggleButtonSize.XL]: 48,
};

// Padding mapping
export const TOGGLE_BUTTON_PADDING_MAP = {
  [ToggleButtonSize.SM]: 2,
  [ToggleButtonSize.MD]: 2.5,
  [ToggleButtonSize.LG]: 3,
  [ToggleButtonSize.XL]: 3.5,
};
